import MediaImage from "./media-image";

export default MediaImage;